

import { useSession } from '../../stores/session';
import { showVuePopup } from '../../utils/showVuePopup';
import Profile from '../../popup/Profile.vue';
import Register from '../../popup/Register.vue';
import Contact from '../../popup/Contact.vue';
import { useAuthStore } from '../../stores/auth';
import { storeToRefs } from 'pinia';
import WalletDeposit from '../../popup/WalletDeposit.vue';
import PromotionList from '../../popup/PromotionList.vue';
import AffiliateLink from '../../popup/AffiliateLink.vue';

export default {
	name: 'Mobile',
	setup() {

		const auth = useAuthStore();
		auth.hydrate();

		const session = useSession();

		const btnClickProfile = async () => {
			session.set('navbar_primary', 'profile');
			await showVuePopup(Profile);
		}

		const btnClickRegister = async () => {
			await showVuePopup(Register);
		}

		const btnClickGame = async () => {
			window.location.href = '/slot';
		}

		const btnClickContact = async () => {
			await showVuePopup(Contact, {}, {
				customClass: {
					closeButton: 'absolute top-0 right-0 size-8! -translate-y-1/3 translate-x-1/3 bg-gray-100 hover:bg-gray-300 shadow rounded-full justify-center! items-center!',
					popup: 'bg-[url(https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/bg-login.webp)] bg-size-[110%_100%] bg-center bg-transparent',
					htmlContainer: 'min-h-[16rem]',
				}
			});
		}

		const btnClickWallet = async () => {
			await showVuePopup(WalletDeposit);
		}

		const btnClickPromotion = async () => {
			await showVuePopup(PromotionList);
		}

		const btnClickAffiliate = async () => {
			await showVuePopup(AffiliateLink);
		}

		return {
			auth,
			btnClickProfile,
			btnClickRegister,
			btnClickGame,
			btnClickContact,
			btnClickWallet,
			btnClickPromotion,
			btnClickAffiliate,
		}
	},
}
